import script from "./InTiTarifa.vue?vue&type=script&lang=ts&setup=true"
export * from "./InTiTarifa.vue?vue&type=script&lang=ts&setup=true"

import "./InTiTarifa.vue?vue&type=style&index=0&id=4c89a348&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c89a348"]])

export default __exports__